import SearchHitSkeleton from './search-hit-skeleton/index.tsx';

const SearchHitsPlaceholder: React.FC = () => {
  return (
    <div>
      <SearchHitSkeleton />
      <SearchHitSkeleton />
      <SearchHitSkeleton />
      <SearchHitSkeleton />
      <SearchHitSkeleton />
      <SearchHitSkeleton />
    </div>
  );
};

export default SearchHitsPlaceholder;
